const lineCasesToCamel = (separator, str) => {
  const parts = str.split(separator);
  const newParts = parts.map((part, index) => {
    if (index !== 0) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }
    return part;
  });

  return newParts.join('');
};

export const snakeToCamelCase = str => lineCasesToCamel('_', str);
export const kebabToCamelCase = str => lineCasesToCamel('-', str);

const camelToLineCases = (separator, str) => {
  const parts = str.split(/(?=[A-Z])/);
  const newParts = parts.map((part, index) => part.charAt(0).toLowerCase() + part.slice(1));
  return newParts.join(separator);
};

export const camelToSnakeCase = str => camelToLineCases('_', str);
export const camelToKebabCase = str => camelToLineCases('-', str);

export const humanPhoneNumber = str => {
  return `(${str.substr(0, 3)}) ${str.substr(3, 3)}-${str.substr(6)}`;
};

export const isAutoCreatedEmail = email => /guest.*@harborplan.com/.test(email);
